/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'extension.charts.aggregateData': '彙總資料',
  'extension.charts.aggregateDataDescription': '當多個列具有相同的值時，將值組合為單一資料點。',
  'extension.charts.category': '類別',
  'extension.charts.customizeTab': '自訂',
  'extension.charts.dataMissing.details': '我們在頁面上找不到此圖表的來源表格。',
  'extension.charts.dataMissing.title': '沒有可顯示的資料',
  'extension.charts.dataTab': '資料',
  'extension.charts.defaultColumnName': '欄 {0}',
  'extension.charts.defaultTitle': '未命名圖表',
  'extension.charts.defaultYLabel': '未命名的軸',
  'extension.charts.extensionTitle': '圖表',
  'extension.charts.height': '繪製區域高度',
  'extension.charts.height.large': '較高',
  'extension.charts.height.medium': '預設',
  'extension.charts.height.small': '較短',
  'extension.charts.horizontal.orientation.label': '水平',
  'extension.charts.insert.tooltip': '插入圖表',
  'extension.charts.legend': '圖例',
  'extension.charts.legend.auto': '自動',
  'extension.charts.legend.bottom': '底部',
  'extension.charts.legend.left': '左側',
  'extension.charts.legend.position': '圖例位置',
  'extension.charts.legend.right': '右側',
  'extension.charts.legend.show': '顯示圖例',
  'extension.charts.legend.top': '頂端',
  'extension.charts.options.label': '圖表選項',
  'extension.charts.options.tooltip': '變更圖表選項',
  'extension.charts.orientation.label': '方向',
  'extension.charts.seriesNames': '資料系列',
  'extension.charts.showPoints': '顯示資料點',
  'extension.charts.smoothLines': '平滑線條',
  'extension.charts.style': '樣式',
  'extension.charts.title': '標題',
  'extension.charts.type.bar': '列',
  'extension.charts.type.fieldDescription': '圖表類型',
  'extension.charts.type.line': '線條',
  'extension.charts.type.pie': '圓餅',
  'extension.charts.userTitle': '標題',
  'extension.charts.vertical.orientation.label': '垂直',
  'extension.charts.xAxis': 'X 軸',
  'extension.charts.xLabel': 'X 軸標籤',
  'extension.charts.yLabel': 'Y 軸標籤',
};
